// @ts-nocheck
import React, { useEffect } from 'react';
import intl from 'react-intl-universal';
import { compose } from '@/utils';
import { ShipMethodsProvider } from './ShipMethodProvider';
import ShipMethodsDataTable from './ShipMethodDataTable';
import withDashboardActions from '@/containers/Dashboard/withDashboardActions';

function ShipMethodsList({ changePreferencesPageTitle }) {
  useEffect(() => {
    changePreferencesPageTitle(intl.get('ship_methods'));
  }, [changePreferencesPageTitle]);

  return (
    <ShipMethodsProvider>
      <ShipMethodsDataTable />
    </ShipMethodsProvider>
  );
}

export default compose(withDashboardActions)(ShipMethodsList);
